<template>
  <div
    v-if="showBalance"
    class="balance flex no-wrap"
  >
    <div
      v-for="key in ['balance', 'credit_limit']"
      :key="key"
      class="q-item flex-1 q-pl-none"
    >
      <q-item-section v-if="account.partner[key].amount">
        <q-item-label class="balance-label text-no-wrap fs-14 text-dark-grey">
          {{ $t(`label.${key}`) }}
        </q-item-label>
        <q-item-label class="text-no-wrap">
          {{ account.partner[key].default }}
        </q-item-label>
      </q-item-section>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useAccountStore } from '~stores/account';

const accountStore = useAccountStore();

const { account, isFamilyUiType, isPartnerManager } = storeToRefs(accountStore);

const showBalance = computed(() => {
  const hasBalance = ['balance', 'credit_limit'].some((key) => account.value?.partner?.[key]?.amount);

  if (!hasBalance) {
    return false;
  }

  return isFamilyUiType.value || isPartnerManager.value;
});
</script>
